// extracted by mini-css-extract-plugin
export var button = "_kz-0";
export var donut = "_kz-1";
export var donutFill = "_kz-3";
export var donutTrack = "_kz-2";